import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Decouples "open the Log Bug form" from where the modal lives. The modal is
 * mounted once in the app shell (LogBugWidgetComponent); any component (e.g.
 * the user menu) can request it to open via `open()`.
 */
@Injectable({ providedIn: 'root' })
export class LogBugUiService {
  private readonly _open$ = new Subject<void>();
  readonly open$ = this._open$.asObservable();

  open(): void {
    this._open$.next();
  }
}
